/**
 * Create filters string to pass as parameter:
 *
 * @param {Array} searchBoxFilters - Array. Properties name to search and compare with searchBox value.
 * @param {Array} otherFilters - Array. Other properties name to search but not with searchBox value.
 * @param {Array} rangeFilters - Array. Range filters that has a Start value and an End value.
 * @param {Object} searchValues - Object. Selected filters values.
 *
 * @returns {Array}
 */
const isSet = (value) => value !== null && value !== undefined && value !== '';

export default (searchBoxFilters, otherFilters, rangeFilters, searchValues) => {
  const nonSearch = (group) => [
    ...otherFilters
      .filter(({ keyName }) => isSet(searchValues[keyName]))
      .map(({ keyName, operator: op = null }) => {
        const value = searchValues[keyName];
        const isObject = typeof value === 'object' && !Array.isArray(value);
        return {
          filterBy: keyName,
          filterValue: isObject ? value?.value : value,
          operator:
            isObject && Object.hasOwn(value, 'operator') ? value?.operator : op,
          group,
        };
      }),
    ...rangeFilters //range value in searchBox needs to be a 2 elements array [MIN, MAX]
      .filter(({ keyName }) => isSet(searchValues[keyName]))
      .flatMap(({ keyName, includeExtremes }) => [
        {
          filterBy: keyName,
          filterValue: searchValues[keyName][0],
          operator: includeExtremes ? '!lt' : 'gt',
          group,
        },
        {
          filterBy: keyName,
          filterValue: searchValues[keyName][1],
          operator: includeExtremes ? '!gt' : 'lt',
          group,
        },
      ]),
  ];

  if (searchValues.searchBox)
    return searchBoxFilters.flatMap((filterBy, index) =>
      filterBy !== 'mobilePhoneNumber' || !isNaN(searchValues.searchBox)
        ? [
            { filterBy, filterValue: searchValues.searchBox, group: index },
            ...nonSearch(index),
          ]
        : []
    );

  return nonSearch(0);
};
